import React from "react";

import { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import TextField from "components/ui/controls/text-field/text-field";
import DropDown from "components/ui/controls/drop-down/drop-down";
import "./ContexteFiscal.css";

const RevenusFoncier = (props) => {
  const { Outil } = props;
  const context = useContext(AppContext);

  const handleAbattement = () => {
    let menu = [
      { value: "Micro", label: "Micro" },
      { value: "Reel", label: "Au réel" },
    ];
    if (context.state[Outil + "IRDirigeantRecette"] > 15000) {
      menu = menu.filter((k) => k.label !== "Micro");
    }
    return menu;
  };
  return (
    <div className="revenuspro-container">
      {/* Header séparé */}
      <div className="header-card">
        <div className="category-column">
          <span className="header-icon">🏠</span>
          Paramètres des revenus fonciers
        </div>
        <div className="value-column">
          <span className="header-icon">💰</span>
          Montant
        </div>
      </div>

      {/* Conteneur des cartes de contenu */}
      <div className="card-list-container">
        {/* Montant des recettes brutes */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">💶</div>
            Montant des recettes brutes
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRDirigeantRecette"]}
              onChange={(e) => {
                context.handleRecetteBrute(Outil, Outil + "IRDirigeantRecette", e);
              }}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>

        {/* Abattement appliqué */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">⚖️</div>
            Abattement appliqué
          </div>
          <div className="value-column">
            <DropDown
              value={context.state[Outil + "IRDirigeantRegimeRevenuFoncier"]}
              onChange={context.handleInputChange(Outil + "IRDirigeantRegimeRevenuFoncier")}
              options={handleAbattement()}
              normal
            />
          </div>
        </div>

        {/* Charges / frais à déduire */}
        {context.state[Outil + "IRDirigeantRegimeRevenuFoncier"] === "Reel" && (
          <div className="card">
            <div className="category-column">
              <div className="titre-icone">🧾</div>
              Charges / frais à déduire
            </div>
            <div className="value-column">
              <TextField
                value={context.state[Outil + "IRDirigeantChargeRevenuFoncier"]}
                onChange={context.handleInputChange(Outil + "IRDirigeantChargeRevenuFoncier")}
                disabled={context.state[Outil + "IRDirigeantRegimeRevenuFoncier"] === "Reel" ? false : true}
                dataType="uint"
                format={{ thousands: " ", unit: " €" }}
                normal
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default RevenusFoncier;
